import { MeDto } from "@growth/dto";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "./api";

export const useMe = (enabled: boolean) =>
  useQuery({
    queryKey: ["me"],
    queryFn: async () => (await api.get<MeDto>("/me")).data,
    enabled,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

/**
 * Ask the server to re-read this account from Clerk now (it otherwise looks every few minutes),
 * taking up any invite waiting for it. The new answer replaces the cached one, so pages that
 * route on it move on by themselves.
 */
export const useRefreshMe = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => (await api.post<MeDto>("/me/refresh")).data,
    onSuccess: (me) => queryClient.setQueryData(["me"], me),
  });
};
